import React, { useState, useEffect } from 'react';
import './App.css';
// import Header from './components/Header'; // Removed
import Footer from './components/Footer';
import MovieInfoPage from './components/MovieInfoPage';
import SeatSelectionPage from './components/SeatSelectionPage';
import RegistrationForm from './components/RegistrationForm';
import ConfirmationPage from './components/ConfirmationPage';
import AdminPanel from './components/AdminPanel';
import { bookingAPI } from './utils/simpleBookingAPI';
import { faviconManager } from './utils/faviconManager';

function App() {
  const [currentStep, setCurrentStep] = useState('movie_info'); // 'movie_info', 'seat_selection', 'registration', 'confirmation'
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [bookedSeats, setBookedSeats] = useState([]); // [{id: 'A1', name: 'John'}]
  const [showAdminPanel, setShowAdminPanel] = useState(false);

    // Load booked seats from API on component mount
  useEffect(() => {
    const loadBookedSeats = async () => {
      try {
        const persistedBookings = await bookingAPI.getBookings();
        setBookedSeats(persistedBookings);
      } catch (error) {
        console.error('Failed to load bookings:', error);
      } finally {
        // Loading complete
      }
    };

    // Initialize favicon for current movie
    faviconManager.setMovieFavicon('woodlawn');

    loadBookedSeats();
  }, []);

  // Admin panel keyboard shortcut (Ctrl+Shift+A)
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.shiftKey && event.key === 'A') {
        event.preventDefault();
        setShowAdminPanel(true);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleBookSeats = () => {
    setCurrentStep('seat_selection');
  };

  const handleProceedToRegistration = (seats) => {
    if (seats.length > 0) {
      setSelectedSeats(seats);
      setCurrentStep('registration');
    } else {
      alert("Please select at least one seat.");
    }
  };


  const handleSubmitRegistration = async (details) => {
    try {
      // Save booking to API
      for (const seat of details.seats) {
        await bookingAPI.addBooking({
          seatId: seat,
          name: details.name,
          phone: details.phone,
          avatar: null // No avatar selection
        });
      }

      setBookingDetails({
        ...details,
        bookingId: `BK${Date.now()}`
      });
      setCurrentStep('confirmation');

      // Update local state with new bookings
      const updatedBookings = await bookingAPI.getBookings();
      setBookedSeats(updatedBookings);

      console.log("Booking saved successfully");
    } catch (error) {
      // Handle booking conflict or error
      alert(`Booking failed: ${error.message}`);
      console.error("Booking failed:", error);

      // Refresh booked seats in case of conflicts
      const currentBookings = await bookingAPI.getBookings();
      setBookedSeats(currentBookings);
    }
  };

  const handleBookAnother = () => {
    setSelectedSeats([]);
    setBookingDetails(null);
    setCurrentStep('movie_info'); // Or 'seat_selection' if they want to book for same movie immediately
  };

  const handleCloseAdminPanel = async () => {
    setShowAdminPanel(false);
    // Refresh booked seats in case admin made changes
    try {
      const updatedBookings = await bookingAPI.getBookings();
      setBookedSeats(updatedBookings);
    } catch (error) {
      console.error('Failed to refresh bookings:', error);
    }
  };

  // New: Back button handler for seat selection
  const handleBackToMovieInfo = () => {
    setCurrentStep('movie_info');
  };

  // Back button handler for registration
  const handleBackToSeatSelection = () => {
    setCurrentStep('seat_selection');
  };

  return (
    <div className="App">
      {/* <Header currentStep={currentStep} /> */}
      <main className="container">
        {currentStep === 'movie_info' && (
          <MovieInfoPage onBookSeats={handleBookSeats} />
        )}
        {currentStep === 'seat_selection' && (
          <SeatSelectionPage
            onProceedToRegistration={handleProceedToRegistration}
            bookedSeats={bookedSeats}
            onBack={handleBackToMovieInfo}
          />
        )}
        {currentStep === 'registration' && (
          <RegistrationForm
            selectedSeats={selectedSeats}
            onSubmitRegistration={handleSubmitRegistration}
            onBack={handleBackToSeatSelection}
          />
        )}
        {currentStep === 'confirmation' && (
          <ConfirmationPage
            bookingDetails={bookingDetails}
            onBookAnother={handleBookAnother}
          />
        )}
      </main>
      <Footer />
      {showAdminPanel && (
        <AdminPanel onClose={handleCloseAdminPanel} />
      )}
    </div>
  );
}

export default App;
